/**
 * Миксин для отслеживания событий через Яндекс.Метрику
 */

// ID счетчика Яндекс.Метрики из index.html
const YANDEX_METRIKA_COUNTER_ID = 102182679;

// Функция для получения URL (как в вашем проекте)
const getCurrentUrlForYM = () => window.location.hostname + window.location.pathname;

// Внутренняя функция отправки события (точно как в вашем проекте)
const _sendEventYM = (idYM, target, params = {}) => {
  if ('ym' in window && idYM) {
    // console.log('[DEBUG] Вызываем ym с:', {idYM, target, params});
    window.ym(idYM, 'reachGoal', target, params);
  }
};

// Глобальная функция (точно как в вашем проекте)
window.sendEventYM = (idYm, target, params = {}, paramsUrl = {}) => {
  if (!idYm || !target) {
    return;
  }

  const resultParams = params ? { ...params } : {};

  if (paramsUrl && paramsUrl.isSendUrl && paramsUrl.nameParams) {
    resultParams[paramsUrl.nameParams] = getCurrentUrlForYM();
  }

  _sendEventYM(idYm, target, resultParams);
};

export default {
  methods: {
    /**
     * Отправляет событие в Яндекс.Метрику (совместимость с предыдущей версией)
     * @param {string} event - Название события
     * @param {Object} params - Параметры события (опционально)
     */
    trackEvent(event, params = {}) {
      window.sendEventYM(YANDEX_METRIKA_COUNTER_ID, event, params);
    },

    /**
     * Новый метод для отправки событий в формате как в другом проекте
     * @param {string} eventName - Название события
     * @param {Object} eventParams - Параметры события
     * @param {Object} options - Дополнительные опции
     */
    sendEventYM(eventName, eventParams = {}, options = {}) {
      window.sendEventYM(YANDEX_METRIKA_COUNTER_ID, eventName, eventParams, options);
    },

    /**
     * Отслеживает клик по кнопке или ссылке
     * @param {string} elementName - Название элемента
     * @param {string} action - Действие (по умолчанию 'click')
     * @param {Object} additionalParams - Дополнительные параметры
     */
    trackClick(elementName, action = 'click', additionalParams = {}) {
      const eventName = `${elementName}_${action}_btn`;
      this.trackEvent(eventName, {
        action,
        element: elementName,
        ...additionalParams
      });
    }
  }
};
